module.exports = __webpack_public_path__ + "img/cmb.620c7350.png";